import lazy from 'utils/lazy';

export const Account = lazy(() => import('./Account'));
